<template>
    <div>
        <b-card
            class="mt-3"
            body-class="mt-3"
            >
            <h6 class="card-title">保険</h6>

            <b-form-group
                label-cols-sm="2"
                label="集荷猶予時間"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-input-group
                    size="sm"
                    append="分"
                    >
                    <b-form-input
                        v-model="model.insurance_grace_period_to_pickup"
                        type="number"
                        class="text-right"
                        >
                    </b-form-input>
                </b-input-group>
                <input-error :errors="error.insurance_grace_period_to_pickup" />

                <div class="text-right">
                    <a
                        href="javascript:void(0)"
                        @click="model.insurance_grace_period_to_pickup = hour ? (hour * 60) : null"
                        v-for="hour in [ null, 8, 12, 24, 36, 48, ]"
                        >
                        <span v-if="hour">
                            {{ hour }}時間
                        </span>
                        <span v-else>
                            制限なし
                        </span>
                    </a>
                </div>
            </b-form-group>

            <b-form-group
                label-cols-sm="2"
                label="修正可能猶予時間"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-input-group
                    size="sm"
                    append="分"
                    >
                    <b-form-input
                        v-model="model.insurance_grace_period_to_edit"
                        type="number"
                        class="text-right"
                        >
                    </b-form-input>
                </b-input-group>
                <input-error :errors="error.insurance_grace_period_to_edit" />

                <div class="text-right">
                    <a
                        href="javascript:void(0)"
                        @click="model.insurance_grace_period_to_edit = hour ? (hour * 60) : null"
                        v-for="hour in [ null, 8, 12, 24, 36, 48, ]"
                        >
                        <span v-if="hour">
                            {{ hour }}時間
                        </span>
                        <span v-else>
                            制限なし
                        </span>
                    </a>
                </div>

            </b-form-group>
        </b-card>

        <div class="text-center mt-3">
            <button type="button" class="btn btn-theme" @click="save">保存</button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'auth_email',
            'trans',
        ])
    },
    data() {
        return {
            model: {
            },
            error: {
            },
        }
    },
    watch: {
        $route: {
            async handler () {
            },
            immediate: true
        }
    },
    mounted() {
        this.fetch()
    },
    methods: {
        async fetch () {
            const response = await this.$store
                .dispatch('app/data')
                .then((response) => {
                    this.model = (response.data.data || {}).setting
                })
                .catch((error) => {
                })
        },
        async save () {
            this.error = {}
            await this.$store
                .dispatch('setting/save', this.model)
                .then((response) => {
                    this.$set(this, 'model', response.data.data)
                })
                .catch((error) => {
                    this.error = error
                })
        },
    },
}
</script>

